//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      showList: false,
      keywords: ""
    };
  },
  computed: {
    lang() {
      return this.$store.getters.getLanguage;
    },
    langList() {
      return this.$store.getters.getLanList;
    },
    path() {
      return this.$store.getters.getPath;
    },
    options() {
      return this.$t("home");
    },
    langName() {
      let arr = this.langList;
      let name = "中文";
      arr.forEach(item => {
        if (item.lang === this.lang) {
          name = item.name;
        }
      });
      return name;
    }
  },
  props: {
    type: {
      default: 2
    }
  },
  methods: {
    search() {
      this.$emit("search", this.keywords);
      this.$router.push(`${this.path}/serach?type=${this.type}`)
    },

    changeLanguage(targetLang) {
      if (this.lang === targetLang) return;
      localStorage.setItem("ZEALAND_LANGUAGE", targetLang);
      // 如果是默认的语言， 意味着没有可以替换的， 那么直接在前面加上前缀
      if (this.path === "") {
        this.$router.push(`/${targetLang}${this.$route.fullPath}`);
      } else {
        this.$router.push(
          this.$route.fullPath.replace(this.lang, targetLang)
        );
        // this.$router.push(`/${targetLang}${this.$route.fullPath}`)
      }
      setTimeout(() => {
        window.location.reload()
      }, 100)
    }
  }
};
